import { Color, Spacing } from '@persona-id/design-tokens';
import { Link } from 'react-router-dom-v5-compat';
import styled from 'styled-components';

import { Paragraph } from 'design-system/components/Text';
import { FontWeight } from 'design-system/variables/text';
import usePermission from 'lib/hooks/usePermission';
import { Permission } from 'lib/permissions';

const Message = styled.div`
  display: grid;
  grid-template-columns: 1fr 15%;
  align-items: center;
  padding: ${Spacing[3]} ${Spacing[5]};
  border: 1px solid ${Color.CoreYellow300};
  background-color: ${Color.CoreYellow100};
  border-radius: ${({ theme }) => theme.element.borderRadius};
`;

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.color.text.primary};
  font-weight: ${FontWeight.Medium};
  text-align: right;
`;

export const ReportTemplateLockedMessage = () => {
  return (
    <Message>
      <Paragraph color='primary'>
        {usePermission(Permission.ReportTemplateWrite)
          ? 'Report template configurations are currently view-only. Please contact us if you would like to configure your settings.'
          : 'You do not have access to configure report templates. Please contact your admin if you would like to configure your settings.'}
      </Paragraph>
      <StyledLink to='/dashboard/contact-us' target='_blank' rel='noreferrer'>
        Contact us
      </StyledLink>
    </Message>
  );
};

export const RecurringLockedMessage = () => (
  <Message>
    <Paragraph color='primary'>
      {usePermission(Permission.ReportTemplateWrite)
        ? 'Continuous monitoring settings are currently view-only. Please contact us if you would like to make changes.'
        : 'You do not have access to configure continuous monitoring settings. Please contact your admin if you would like to make changes.'}
    </Paragraph>
    <StyledLink to='/dashboard/contact-us' target='_blank' rel='noreferrer'>
      Contact us
    </StyledLink>
  </Message>
);
